import React from 'react';
import {
  Folder,
  FolderOpen,
  FolderPlus,
  FolderMinus,
  FolderX,
  FolderInput,
  FolderOutput,
  FolderKey,
  FolderLock,
  FolderCog,
  FolderSearch,
  FolderTree,
  FolderGit2,
  FolderKanban,
  FolderArchive,
  FolderCheck,
  FolderClosed,
  FolderDown,
  FolderEdit,
  FolderGit,
  FolderHeart,
  FolderRoot,
  FolderSync,
  FolderUp,
  Box,
  Briefcase,
  Book,
  BookOpen,
  Bookmark,
  Building,
  Building2,
  Calendar,
  Camera,
  Code,
  CodepenIcon,
  Coffee,
  Cog,
  Command,
  Compass,
  Copy,
  CreditCard,
  Crop,
  DollarSign,
  Download,
  Edit,
  Eye,
  File,
  FileText,
  Film,
  Flag,
  Gift,
  Globe,
  Headphones,
  Heart,
  Home,
  Image,
  Inbox,
  Key,
  Layout,
  Link,
  List,
  Lock,
  Mail,
  Map,
  MessageCircle,
  MessageSquare,
  Monitor,
  Moon,
  Music,
  Package,
  Phone,
  Pin,
  Play,
  Printer,
  Search,
  Send,
  Share,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Star,
  Sun,
  Tag,
  Terminal,
  Wrench,
  Trash,
  Trophy,
  Tv,
  Type,
  Umbrella,
  Video,
  Wallet,
  Watch,
  Wifi,
  Zap,
  Archive,
} from 'lucide-react';

// Material Design Icons
import {
  MdFolder,
  MdFolderOpen,
  MdFolderSpecial,
  MdCreateNewFolder,
  MdFolderShared,
  MdSnippetFolder,
  MdWork,
  MdSchool,
  MdHome,
  MdSettings,
  MdFavorite,
  MdBookmark,
  MdStar,
  MdStarBorder,
  MdLabel,
  MdLabelOutline,
  MdDescription,
  MdAssignment,
  MdCode,
  MdCloud,
  MdPerson,
  MdGroup,
  MdBusiness,
  MdComputer,
  MdDevices,
  MdPhoneAndroid,
  MdLaptop,
  MdDesktopMac,
  MdKeyboard,
  MdMouse,
  MdSecurity,
  MdLock,
  MdLockOpen,
  MdEnhancedEncryption,
  MdShield,
  MdVerifiedUser,
  MdBugReport,
  MdBuild,
  MdAccountBalance,
  MdAccountBalanceWallet,
  MdPayment,
  MdAttachMoney,
  MdLocalAtm,
  MdCreditCard,
  MdShoppingCart,
  MdShoppingBasket,
  MdLocalShipping,
  MdStorefront,
  MdStore,
  MdRestaurant,
  MdLocalCafe,
  MdLocalBar,
  MdLocalDining,
  MdLocalHotel,
  MdFlight,
  MdDirectionsCar,
  MdLocalTaxi,
  MdTrain,
  MdDirectionsSubway,
  MdDirectionsBus,
  MdDirectionsBike,
  MdDirectionsWalk,
  MdMap,
  MdMyLocation,
  MdLocationOn,
  MdNearMe,
  MdExplore,
  MdCamera,
  MdPhoto,
  MdPhotoLibrary,
  MdMovie,
  MdMusicNote,
  MdPalette,
  MdBrush,
  MdColorLens,
  MdInsertEmoticon,
  MdTagFaces,
  MdMood,
  MdMoodBad,
  MdSentimentSatisfied,
  MdSentimentDissatisfied,
  MdSentimentVeryDissatisfied,
  MdThumbUp,
  MdThumbDown,
  MdFeedback,
  MdMessage,
  MdChat,
  MdEmail,
  MdCall,
  MdContacts,
  MdContactPhone,
  MdContactMail,
  MdPermContactCalendar,
  MdEvent,
  MdDateRange,
  MdSchedule,
  MdAccessTime,
  MdAlarm,
  MdTimer,
  MdHourglassEmpty,
  MdNotifications,
  MdNotificationsActive,
  MdNotificationsNone,
  MdNotificationsPaused,
  MdWifi,
  MdBluetooth,
  MdSignalCellular4Bar,
  MdBatteryFull,
  MdBatteryAlert,
  MdBatteryChargingFull,
  MdPower,
  MdFlashOn,
  MdAirplanemodeActive,
  MdDoNotDisturb,
  MdVpnKey,
  MdLanguage,
  MdTranslate,
  MdPublic,
  MdCloudCircle,
  MdCloudDone,
  MdCloudOff,
  MdWbSunny,
  MdAcUnit,
  MdWaves,
  MdWaterDrop,
  MdLocalFireDepartment,
  MdNature,
  MdEco,
  MdPets,
  MdSpa,
  MdSportsBasketball,
  MdSportsFootball,
  MdSportsSoccer,
  MdSportsTennis,
  MdSportsVolleyball,
  MdSportsEsports,
  MdCasino,
  MdLocalMovies,
  MdLocalActivity,
  MdTheaters,
  MdTv,
  MdVideogameAsset,
  MdSportsHandball,
  MdSportsRugby,
  MdSportsHockey,
  MdSportsKabaddi,
  MdSportsCricket,
  MdSportsMma,
  MdSportsMotorsports,
  MdFastfood,
  MdLocalPizza,
  MdLocalGroceryStore,
  MdLocalFlorist,
  MdLocalLaundryService,
  MdLocalLibrary,
  MdLocalMall,
  MdLocalOffer,
  MdLocalParking,
  MdLocalPharmacy,
  MdLocalPostOffice,
  MdLocalPrintshop,
  MdLocalSee,
  MdAttachFile,
  MdAttachEmail,
  MdCloudDownload,
  MdCloudUpload,
  MdDriveFileMove,
  MdDriveFileMoveOutline,
  MdDriveFileRenameOutline,
  MdFileCopy,
  MdFileDownload,
  MdFilePresent,
  MdFileUpload,
  MdFolderCopy,
  MdFolderDelete,
  MdFolderZip,
  MdFormatColorFill,
  MdFormatColorReset,
  MdFormatColorText,
  MdFormatIndentDecrease,
  MdFormatIndentIncrease,
  MdFormatItalic,
  MdFormatLineSpacing,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdFormatPaint,
  MdFormatQuote,
  MdFormatShapes,
  MdFormatSize,
  MdFormatStrikethrough,
  MdFormatTextdirectionLToR,
  MdFormatTextdirectionRToL,
  MdFormatUnderlined,
  MdFunctions,
  MdHeight,
  MdInsertChart,
  MdInsertComment,
  MdInsertDriveFile,
  MdInsertInvitation,
  MdInsertLink,
  MdInsertPhoto,
  MdLineStyle,
  MdLineWeight,
  MdMergeType,
  MdModeComment,
  MdModeEdit,
  MdMonetizationOn,
  MdMoneyOff,
  MdMultilineChart,
  MdNotes,
  MdPieChart,
  MdPublish,
  MdQueryStats,
  MdRedo,
  MdRemoveRedEye,
  MdScatterPlot,
  MdSchema,
  MdScore,
  MdShortText,
  MdShowChart,
  MdSpaceBar,
  MdStrikethroughS,
  MdSubscript,
  MdSuperscript,
  MdTableChart,
  MdTableRows,
  MdTextFields,
  MdTitle,
  MdUndo,
  MdVerticalAlignBottom,
  MdVerticalAlignCenter,
  MdVerticalAlignTop,
  MdWrapText,
} from 'react-icons/md';

// Common icons that appear at the top of the dropdown
export const COMMON_ICONS = {
  Folder,
  Archive,
  Book,
  Box,
  Code,
  Heart,
  Package,
  Star,
} as const;

// All folder-related icons
export const FOLDER_ICONS = {
  Folder,
  FolderOpen,
  FolderPlus,
  FolderMinus,
  FolderX,
  FolderInput,
  FolderOutput,
  FolderKey,
  FolderLock,
  FolderCog,
  FolderSearch,
  FolderTree,
  FolderGit2,
  FolderKanban,
  FolderArchive,
  FolderCheck,
  FolderClosed,
  FolderDown,
  FolderEdit,
  FolderGit,
  FolderHeart,
  FolderRoot,
  FolderSync,
  FolderUp,
} as const;

// All other icons
export const OTHER_ICONS = {
  Box,
  Briefcase,
  Book,
  BookOpen,
  Bookmark,
  Building,
  Building2,
  Calendar,
  Camera,
  Code,
  CodepenIcon,
  Coffee,
  Cog,
  Command,
  Compass,
  Copy,
  CreditCard,
  Crop,
  DollarSign,
  Download,
  Edit,
  Eye,
  File,
  FileText,
  Film,
  Flag,
  Gift,
  Globe,
  Headphones,
  Heart,
  Home,
  Image,
  Inbox,
  Key,
  Layout,
  Link,
  List,
  Lock,
  Mail,
  Map,
  MessageCircle,
  MessageSquare,
  Monitor,
  Moon,
  Music,
  Package,
  Phone,
  Pin,
  Play,
  Printer,
  Search,
  Send,
  Share,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Star,
  Sun,
  Tag,
  Terminal,
  Wrench,
  Trash,
  Trophy,
  Tv,
  Type,
  Umbrella,
  Video,
  Wallet,
  Watch,
  Wifi,
  Zap,
} as const;

// Material Design Folder Icons
export const MATERIAL_FOLDER_ICONS = {
  MdFolder,
  MdCreateNewFolder,
  MdDriveFileMove,
  MdDriveFileMoveOutline,
  MdFolderCopy,
  MdFolderDelete,
  MdFolderOpen,
  MdFolderShared,
  MdFolderSpecial,
  MdFolderZip,
  MdSnippetFolder,
} as const;

// Material Design Common Icons
export const MATERIAL_COMMON_ICONS = {
  MdAccountBalanceWallet,
  MdAssignment,
  MdBookmark,
  MdBusiness,
  MdCloud,
  MdCode,
  MdDescription,
  MdEnhancedEncryption,
  MdFavorite,
  MdGroup,
  MdHome,
  MdKeyboard,
  MdLabel,
  MdLabelOutline,
  MdLocalAtm,
  MdLocalShipping,
  MdLockOpen,
  MdMouse,
  MdPerson,
  MdSchool,
  MdSettings,
  MdShoppingBasket,
  MdStar,
  MdStarBorder,
  MdStorefront,
  MdVerifiedUser,
  MdWork,
} as const;

// Material Design Category Icons
export const MATERIAL_CATEGORY_ICONS = {
  MdAccessTime,
  MdAccountBalance,
  MdAcUnit,
  MdAirplanemodeActive,
  MdAlarm,
  MdAttachEmail,
  MdAttachFile,
  MdAttachMoney,
  MdBatteryAlert,
  MdBatteryChargingFull,
  MdBatteryFull,
  MdBluetooth,
  MdBrush,
  MdBugReport,
  MdBuild,
  MdCall,
  MdCamera,
  MdCasino,
  MdChat,
  MdCloudCircle,
  MdCloudDone,
  MdCloudDownload,
  MdCloudOff,
  MdCloudUpload,
  MdColorLens,
  MdComputer,
  MdContactMail,
  MdContactPhone,
  MdContacts,
  MdCreditCard,
  MdDateRange,
  MdDesktopMac,
  MdDevices,
  MdDirectionsBike,
  MdDirectionsBus,
  MdDirectionsCar,
  MdDirectionsSubway,
  MdDirectionsWalk,
  MdDoNotDisturb,
  MdDriveFileMove,
  MdDriveFileMoveOutline,
  MdDriveFileRenameOutline,
  MdEco,
  MdEmail,
  MdEvent,
  MdExplore,
  MdFastfood,
  MdFeedback,
  MdFileCopy,
  MdFileDownload,
  MdFilePresent,
  MdFileUpload,
  MdFlashOn,
  MdFlight,
  MdFormatColorFill,
  MdFormatColorReset,
  MdFormatColorText,
  MdFormatIndentDecrease,
  MdFormatIndentIncrease,
  MdFormatItalic,
  MdFormatLineSpacing,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdFormatPaint,
  MdFormatQuote,
  MdFormatShapes,
  MdFormatSize,
  MdFormatStrikethrough,
  MdFormatTextdirectionLToR,
  MdFormatTextdirectionRToL,
  MdFormatUnderlined,
  MdFunctions,
  MdHeight,
  MdHourglassEmpty,
  MdInsertChart,
  MdInsertComment,
  MdInsertDriveFile,
  MdInsertEmoticon,
  MdInsertInvitation,
  MdInsertLink,
  MdInsertPhoto,
  MdLanguage,
  MdLaptop,
  MdLineStyle,
  MdLineWeight,
  MdLocalActivity,
  MdLocalBar,
  MdLocalCafe,
  MdLocalDining,
  MdLocalFireDepartment,
  MdLocalFlorist,
  MdLocalGroceryStore,
  MdLocalHotel,
  MdLocalLaundryService,
  MdLocalLibrary,
  MdLocalMall,
  MdLocalMovies,
  MdLocalOffer,
  MdLocalParking,
  MdLocalPharmacy,
  MdLocalPizza,
  MdLocalPostOffice,
  MdLocalPrintshop,
  MdLocalSee,
  MdLocalTaxi,
  MdLocationOn,
  MdLock,
  MdMap,
  MdMergeType,
  MdMessage,
  MdModeComment,
  MdModeEdit,
  MdMonetizationOn,
  MdMoneyOff,
  MdMood,
  MdMoodBad,
  MdMovie,
  MdMultilineChart,
  MdMusicNote,
  MdMyLocation,
  MdNature,
  MdNearMe,
  MdNotes,
  MdNotifications,
  MdNotificationsActive,
  MdNotificationsNone,
  MdNotificationsPaused,
  MdPalette,
  MdPayment,
  MdPermContactCalendar,
  MdPets,
  MdPhoneAndroid,
  MdPhoto,
  MdPhotoLibrary,
  MdPieChart,
  MdPower,
  MdPublic,
  MdPublish,
  MdQueryStats,
  MdRedo,
  MdRemoveRedEye,
  MdRestaurant,
  MdScatterPlot,
  MdSchedule,
  MdSchema,
  MdScore,
  MdSecurity,
  MdSentimentDissatisfied,
  MdSentimentSatisfied,
  MdSentimentVeryDissatisfied,
  MdShield,
  MdShoppingCart,
  MdShortText,
  MdShowChart,
  MdSignalCellular4Bar,
  MdSpa,
  MdSpaceBar,
  MdSportsBasketball,
  MdSportsCricket,
  MdSportsEsports,
  MdSportsFootball,
  MdSportsHandball,
  MdSportsHockey,
  MdSportsKabaddi,
  MdSportsMma,
  MdSportsMotorsports,
  MdSportsRugby,
  MdSportsSoccer,
  MdSportsTennis,
  MdSportsVolleyball,
  MdStore,
  MdStrikethroughS,
  MdSubscript,
  MdSuperscript,
  MdTableChart,
  MdTableRows,
  MdTagFaces,
  MdTextFields,
  MdTheaters,
  MdThumbDown,
  MdThumbUp,
  MdTimer,
  MdTitle,
  MdTrain,
  MdTranslate,
  MdTv,
  MdUndo,
  MdVerticalAlignBottom,
  MdVerticalAlignCenter,
  MdVerticalAlignTop,
  MdVideogameAsset,
  MdVpnKey,
  MdWaterDrop,
  MdWaves,
  MdWbSunny,
  MdWifi,
  MdWrapText,
} as const;

// Material Design Filled Icons (using the same icons but labeled as "Filled" in UI)
export const MATERIAL_FILLED_ICONS = {
  MdAccessTimeFilled: MdAccessTime,
  MdAccountBalanceFilled: MdAccountBalance,
  MdAccountBalanceWalletFilled: MdAccountBalanceWallet,
  MdAlarmFilled: MdAlarm,
  MdAssignmentFilled: MdAssignment,
  MdAttachEmailFilled: MdAttachEmail,
  MdAttachFileFilled: MdAttachFile,
  MdAttachMoneyFilled: MdAttachMoney,
  MdBookmarkFilled: MdBookmark,
  MdBrushFilled: MdBrush,
  MdBugReportFilled: MdBugReport,
  MdBuildFilled: MdBuild,
  MdBusinessFilled: MdBusiness,
  MdCallFilled: MdCall,
  MdCameraFilled: MdCamera,
  MdChatFilled: MdChat,
  MdCloudDownloadFilled: MdCloudDownload,
  MdCloudFilled: MdCloud,
  MdCloudUploadFilled: MdCloudUpload,
  MdCodeFilled: MdCode,
  MdColorLensFilled: MdColorLens,
  MdComputerFilled: MdComputer,
  MdContactMailFilled: MdContactMail,
  MdContactPhoneFilled: MdContactPhone,
  MdContactsFilled: MdContacts,
  MdCreateNewFolderFilled: MdCreateNewFolder,
  MdCreditCardFilled: MdCreditCard,
  MdDateRangeFilled: MdDateRange,
  MdDescriptionFilled: MdDescription,
  MdDesktopMacFilled: MdDesktopMac,
  MdDevicesFilled: MdDevices,
  MdDirectionsBikeFilled: MdDirectionsBike,
  MdDirectionsBusFilled: MdDirectionsBus,
  MdDirectionsCarFilled: MdDirectionsCar,
  MdDirectionsSubwayFilled: MdDirectionsSubway,
  MdDirectionsWalkFilled: MdDirectionsWalk,
  MdEmailFilled: MdEmail,
  MdEnhancedEncryptionFilled: MdEnhancedEncryption,
  MdEventFilled: MdEvent,
  MdExploreFilled: MdExplore,
  MdFavoriteFilled: MdFavorite,
  MdFileCopyFilled: MdFileCopy,
  MdFileDownloadFilled: MdFileDownload,
  MdFileUploadFilled: MdFileUpload,
  MdFlightFilled: MdFlight,
  MdFolderCopyFilled: MdFolderCopy,
  MdFolderDeleteFilled: MdFolderDelete,
  MdFolderFilled: MdFolder,
  MdFolderOpenFilled: MdFolderOpen,
  MdFolderSharedFilled: MdFolderShared,
  MdFolderSpecialFilled: MdFolderSpecial,
  MdFolderZipFilled: MdFolderZip,
  MdFormatColorTextFilled: MdFormatColorText,
  MdGroupFilled: MdGroup,
  MdHomeFilled: MdHome,
  MdHourglassEmptyFilled: MdHourglassEmpty,
  MdInsertChartFilled: MdInsertChart,
  MdInsertPhotoFilled: MdInsertPhoto,
  MdKeyboardFilled: MdKeyboard,
  MdLabelFilled: MdLabel,
  MdLabelOutlineFilled: MdLabelOutline,
  MdLaptopFilled: MdLaptop,
  MdLocalAtmFilled: MdLocalAtm,
  MdLocalBarFilled: MdLocalBar,
  MdLocalCafeFilled: MdLocalCafe,
  MdLocalDiningFilled: MdLocalDining,
  MdLocalHotelFilled: MdLocalHotel,
  MdLocalShippingFilled: MdLocalShipping,
  MdLocalTaxiFilled: MdLocalTaxi,
  MdLocationOnFilled: MdLocationOn,
  MdLockFilled: MdLock,
  MdLockOpenFilled: MdLockOpen,
  MdMapFilled: MdMap,
  MdMessageFilled: MdMessage,
  MdMouseFilled: MdMouse,
  MdMovieFilled: MdMovie,
  MdMusicNoteFilled: MdMusicNote,
  MdMyLocationFilled: MdMyLocation,
  MdNearMeFilled: MdNearMe,
  MdNotesFilled: MdNotes,
  MdNotificationsActiveFilled: MdNotificationsActive,
  MdNotificationsFilled: MdNotifications,
  MdNotificationsNoneFilled: MdNotificationsNone,
  MdNotificationsPausedFilled: MdNotificationsPaused,
  MdPaletteFilled: MdPalette,
  MdPaymentFilled: MdPayment,
  MdPersonFilled: MdPerson,
  MdPhoneAndroidFilled: MdPhoneAndroid,
  MdPhotoFilled: MdPhoto,
  MdPhotoLibraryFilled: MdPhotoLibrary,
  MdPieChartFilled: MdPieChart,
  MdRestaurantFilled: MdRestaurant,
  MdScheduleFilled: MdSchedule,
  MdSchoolFilled: MdSchool,
  MdSecurityFilled: MdSecurity,
  MdSettingsFilled: MdSettings,
  MdShieldFilled: MdShield,
  MdShoppingBasketFilled: MdShoppingBasket,
  MdShoppingCartFilled: MdShoppingCart,
  MdSnippetFolderFilled: MdSnippetFolder,
  MdStarBorderFilled: MdStarBorder,
  MdStarFilled: MdStar,
  MdStoreFilled: MdStore,
  MdStorefrontFilled: MdStorefront,
  MdTimerFilled: MdTimer,
  MdTrainFilled: MdTrain,
  MdVerifiedUserFilled: MdVerifiedUser,
  MdWorkFilled: MdWork,
} as const;

// Helper types
export type IconName =
  | keyof typeof COMMON_ICONS
  | keyof typeof FOLDER_ICONS
  | keyof typeof OTHER_ICONS
  | keyof typeof MATERIAL_FOLDER_ICONS
  | keyof typeof MATERIAL_COMMON_ICONS
  | keyof typeof MATERIAL_CATEGORY_ICONS
  | keyof typeof MATERIAL_FILLED_ICONS;

export type IconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;

// Helper function to get icon component
export function getIconComponent(name: string): IconComponent {
  return (
    COMMON_ICONS[name as keyof typeof COMMON_ICONS] ||
    FOLDER_ICONS[name as keyof typeof FOLDER_ICONS] ||
    OTHER_ICONS[name as keyof typeof OTHER_ICONS] ||
    MATERIAL_FOLDER_ICONS[name as keyof typeof MATERIAL_FOLDER_ICONS] ||
    MATERIAL_COMMON_ICONS[name as keyof typeof MATERIAL_COMMON_ICONS] ||
    MATERIAL_CATEGORY_ICONS[name as keyof typeof MATERIAL_CATEGORY_ICONS] ||
    MATERIAL_FILLED_ICONS[name as keyof typeof MATERIAL_FILLED_ICONS] ||
    Folder
  );
}
